
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FolderService } from '@commoncore/services/folder.service';
import { ListService } from '@commoncore/services/list.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { GamingService } from '@mainrepo/app/core/services/gaming.service';
import { ShareAccessService } from '@mainrepo/app/core/services/share-access.service';
import { ConnectionService } from 'ng-connection-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RedirectionService } from 'projects/promotionsrepo/src/app/core/services/redirection.service';
import { CleverTapEventsService } from './clevertap-events-service';
import { ContainerHeightCalculatorService } from './container-height-calculator.service';
import { ContextMenuMobileService } from './context-menu-mobile.service';
import { ContextMenuService } from './context-menu.service';
import { CustomMetadataService } from './custom-metadata.service';
import { CustomSortService } from './custom-sort.service';
import { DirectivesService } from './directives.service';
import { FileOperationsService } from './file-operations.service';
import { GoogleAnalyticsEventsService } from './ga-events-service';
// import { CookieService } from 'ngx-cookie-service';
import { FileOperationsHelperService } from '@mainrepo/app/core/services/file-operations-helper.service';
import { PeopleService } from '@mainrepo/app/core/services/people.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ContextmenuOperationsService } from './contextmenu-operations.service';
import { InappWebviewService } from './inapp-webview.service';
import { LazyInjectorService } from './lazy-injector.service';
import { LazyLoadImgService } from './lazy-load-img.service';
import { LocalStorageSvc } from './localStorage.service';
import { LoggerService } from './logger.service';
import { PaginationService } from './pagination.service';
import { SearchService } from './search.service';
import { SessionStorageService } from './session-storage.service';
import { LazyLoadVirtualImageService } from './virtual-img-lazy-load.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public containerHeightCalc:any;
  getGamingervice: any;
  

  

  constructor(
    private http: HttpClient,
    public  router: Router,
    private connectionService: ConnectionService,
    public  deviceService: DeviceDetectorService,
    public  metaTagService:Meta,
    private route:ActivatedRoute,
    private folderService:FolderService,
    private universalService:UniversalService,
    private listService:ListService,
    private fileOpsService:FileOperationsService,
    private contextMenuService:ContextMenuService,
    private contextMenuMobileService:ContextMenuMobileService,
    public  loggerService:LoggerService,
    private localStorageSvc:LocalStorageSvc,
    private cleverTapEventsService :CleverTapEventsService,
    private  googleAnalyticsService : GoogleAnalyticsEventsService,
    public shareAccessService:ShareAccessService,
    public searchService:SearchService,
    public customMetadataService:CustomMetadataService,
    public sessionStorageSvc:SessionStorageService,
    // public cookieService:CookieService,
    public inAppWebviewService:InappWebviewService,
    public customSort : CustomSortService,
    public redirectionService:RedirectionService,
    public directiveService: DirectivesService,
    private recalculateHeightService : ContainerHeightCalculatorService,
    private gamingService: GamingService,
    public dbService : NgxIndexedDBService,
    private contextMenuOpsService: ContextmenuOperationsService,
    private fileOperationsHelperService:FileOperationsHelperService,
    private lazyInjectorService : LazyInjectorService,
    private LazyLoadImgService : LazyLoadImgService,
    private peopleService : PeopleService,
    private paginationService : PaginationService,
    private virtualLazyLoadService : LazyLoadVirtualImageService
    ) {}

  public getcustomSortRef(){
    return this.customSort
  }

  public getHttpClientRef(){
    return this.http
  }
  
  public getRouterRef(){
    return this.router;
  }

  public getConnectionSvcRef(){
    return this.connectionService;
  }

  public getActivatedRoute(){
    return this.route;
  }

  public getDeviceServiceRef(){
    return this.deviceService;
  }

  public getFolderServiceRef(){
    return this.folderService;
  }

  public getUniversalServiceRef(){
    return this.universalService;
  }
  public getListServiceRef(){
    return this.listService;
  }

  public getMetaServiceRef(){
    return this.metaTagService;
  }

  public getFileOperationServiceRef(){
    return this.fileOpsService
  }

  public getContextMenuServiceRef(){
    return this.contextMenuService;
  }

  public getContextMenuMobileServiceRef(){
    return this.contextMenuMobileService;
  }

  public getLoggerServiceRef(){
    return this.loggerService;
  }

  getLocalStorageSvcRef(){
    return this.localStorageSvc;
  }

  getCleverTapEventsvc(){
    return this.cleverTapEventsService
  }
  getGoogleAnalyticsEventsvc(){
    return this.googleAnalyticsService
  }
  getShareAccessServiceRef(){
    return this.shareAccessService;
  }

  getSearchServiceRef(){
    return this.searchService;
  }
  getCustomMetadataServiceRef(){
    return this.customMetadataService;
  }

  getSessionStorageSvcRef(){
    return this.sessionStorageSvc;
  }

  // getCookieServiceRef(){
  //   return this.cookieService;
  // }

  getInAppWebviewService(){
    return this.inAppWebviewService;
  }

  getRedirectionServiceRef(){
    return this.redirectionService;
  }

  getContainerHeightCalculatorService(){
    return this.recalculateHeightService;
  }

  getDirectiveServiceRef(){
    return this.directiveService
  }
  getGamingServiceRef(){
    return this.gamingService
  }

  getContextMenuOperationsServiceRef(){
    return this.contextMenuOpsService;
  }

  getFileOperationsHelperServiceRef(){
    return this.fileOperationsHelperService;
  }

  getDbService() {
    return this.dbService;
  }
  getLazyInjectorServiceRef(){
    return this.lazyInjectorService;
  }
  getLazyLoadImgServiceRef(){
    return this.LazyLoadImgService;
  }

  public getPeopleServiceRef(){
    return this.peopleService;
  }

  getVirtualLazyLoadImgServiceRef(){
    return this.virtualLazyLoadService;
  }

  getPaginationServiceRef(){
    return this.paginationService;
  }
}
